export const ChildIterator = ({children}) => {
	return (
		children.map(child => {
			return (
				child
			)
		})
	)
}
